import {
  GET_SEARCH_RESULTS,
  GET_SEARCH_RESULTS_SUCCESS,
  GET_SEARCH_RESULTS_UPDATE,
  GET_SEARCH_RESULTS_ERROR } from "../constants/actionTypes";

const initialState = {
  isLoading: false,
  isFinished: false,
  isError: false,
  error: null,
  data: null,
  results: [],
};


export default (state = initialState, action) => {
  switch (action.type) {
    case GET_SEARCH_RESULTS: {
      return {
        ...state,
        isLoading: true,
        isFinished: false,
        isError: false,
        error: null,
      };
    }

    case GET_SEARCH_RESULTS_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        isFinished: true,
        results: action.payload,
      };
    }

    case GET_SEARCH_RESULTS_UPDATE: {
      return {
        ...state,
        isLoading: false,
        isFinished: true,
        results: state.results.concat(action.payload),
      };
    }

    case GET_SEARCH_RESULTS_ERROR: {
      return {
        ...state,
        isLoading: false,
        isFinished: true,
        isError: true,
        error: action.payload,
      };
    }

    default: {
      return state;
    }
  }
};
